export default "__VITE_ASSET__b76d0d2e__"